

/**
 * Party command
 */
export function eggStartParty() {
    setInterval(() => {
        const elements = document.getElementsByTagName('div');
        for (let i = 0; i < elements.length; i++) {
            const element = elements.item(i);
            const r = Math.floor(Math.random() * 255);
            const g = Math.floor(Math.random() * 255);
            const b = Math.floor(Math.random() * 255);
            const jumpings = ['a-jumping', 'a-jumping-1', 'a-jumping-2'];
            if (element) {
                element.style.backgroundColor = `rgb(${r}, ${g}, ${b})`;
                for (const jum of jumpings) element.classList.remove(jum);
                element.classList.add(jumpings[Math.floor(Math.random() * jumpings.length)]);
            }
        }
    }, 200);
}


/**
 * Party command
 */
export function eggStartParty() {
    setInterval(() => {
        const elements = document.getElementsByTagName('div');
        for (let i = 0; i < elements.length; i++) {
            const element = elements.item(i);
            const r = Math.floor(Math.random() * 255);
            const g = Math.floor(Math.random() * 255);
            const b = Math.floor(Math.random() * 255);
            const jumpings = ['a-jumping', 'a-jumping-1', 'a-jumping-2'];
            if (element) {
                element.style.backgroundColor = `rgb(${r}, ${g}, ${b})`;
                for (const jum of jumpings) element.classList.remove(jum);
                element.classList.add(jumpings[Math.floor(Math.random() * jumpings.length)]);
            }
        }
    }, 200);
}
